var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @file 基础表格组件
 * 基于 antd Table 并且样式符合设计规范
 */
import TableAntd from 'antd/es/table';
import styled, { css } from 'styled-components';
import { State } from '../State';
import { useTranslation } from '../i18n';
export * from './types';
export const TableRaw = (_a) => {
    var { showEvenRowBackground = true, showRowHoverBackground = true, showRowSelectedBackground = true, bordered = false, noBorderRadius = false, borderedInner = false, size = 'middle', empty } = _a, props = __rest(_a, ["showEvenRowBackground", "showRowHoverBackground", "showRowSelectedBackground", "bordered", "noBorderRadius", "borderedInner", "size", "empty"]);
    const { t } = useTranslation();
    return (_jsx(TableStyled
    // 不使用原来的 bordered 和 size, 因为它们的样式不符合我们的需求
    , Object.assign({ 
        // 不使用原来的 bordered 和 size, 因为它们的样式不符合我们的需求
        _bordered: bordered, _noBorderRadius: noBorderRadius, _size: size, borderedInner: borderedInner, 
        // 肯定不用它的 pagination, 需要 pagination 时需使用我们自己的 Pagination 组件
        pagination: false, rowClassName: (_record, index) => (index % 2 === 1 ? 'even-row' : ''), showEvenRowBackground: showEvenRowBackground, showRowHoverBackground: showRowHoverBackground, showRowSelectedBackground: showRowSelectedBackground, locale: {
            emptyText: empty !== null && empty !== void 0 ? empty : _jsx(State.Empty, { description: t('暂无数据') }, void 0),
        } }, props), void 0));
};
export const Table = TableRaw;
const TableStyled = styled(TableAntd) `
  &&& {
    border-radius: 0;
    border-top: 1px solid #e8e8e8;
    border-bottom: 1px solid #e8e8e8;

    /* 单元格 */
    td.ant-table-cell {
      height: ${props => (props._size === 'small' ? '35px' : '43px')};
      padding: ${props => (props._size === 'small' ? '0 24px' : '0 12px')};
      font-size: 13px;
    }

    /* 表头 */
    th.ant-table-cell {
      padding: ${props => (props._size === 'small' ? '7px 24px' : '10px 12px')};
      font-size: ${props => (props._size === 'small' ? '13px' : '14px')};

      /* 表头描边 */
      border-bottom: 1px solid
        ${props => (props.borderedInner ? props.theme.divider._2 : '#e8e8e8')};
    }

    .ant-table-selection-column {
      padding-left: 12px;
    }

    .ant-table-column-sorters {
      padding: 0;
    }

    .ant-table-tbody > tr > td {
      border-bottom: 1px solid
        ${props => (props.borderedInner ? props.theme.divider._2 : '#e8e8e8')};
    }

    .ant-table-tbody > tr:last-child > td {
      border-bottom: none;
    }

    /* 行 hover 时的背景色 */
    .ant-table-tbody > tr.ant-table-row:hover > td {
      background: ${props => props.showRowHoverBackground ? props.theme.brand._5 : 'transparent'};
    }

    /* 行被选中时的背景色 */
    .ant-table-tbody > tr.ant-table-row.ant-table-row-selected > td {
      background: ${p => p.showRowSelectedBackground ? p.theme.brand._5 : 'transparent'};
    }

    /* 隐藏表头列之间的竖线 */
    .ant-table-thead
      > tr
      > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
      display: none;
    }

    /* 偶数行的背景色 */
    ${props => props.showEvenRowBackground &&
    css `
        & .ant-table-tbody > tr.ant-table-row.even-row {
          &:not(.ant-table-row-selected) td {
            background: ${props.theme.background._1};
          }
          &:hover td {
            background: ${props.showRowHoverBackground
        ? props.theme.brand._5
        : props.theme.background._1};
          }
        }
      `}

    ${props => props._bordered &&
    css `
        overflow: hidden;
        border: 1px solid #e8e8e8;
        border-right: none;
        border-radius: ${props._noBorderRadius
        ? 0
        : props._size === 'small'
            ? '4px'
            : '6px'};

        tbody tr:last-child td.ant-table-cell {
          border-bottom: 0;
        }
      `}

    ${props => props.borderedInner &&
    css `
        thead tr th.ant-table-cell,
        tbody tr td.ant-table-cell {
          border-right: 1px solid ${props.theme.divider._2};
        }
      `}

      ${props => props._bordered &&
    css `
        thead tr th.ant-table-cell:last-child,
        tbody tr td.ant-table-cell:last-child {
          border-right: 1px solid #e8e8e8;
        }
      `};
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvVGFibGUvaW5kZXgudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7OztBQUFBOzs7R0FHRztBQUNILE9BQU8sU0FBUyxNQUFNLGVBQWUsQ0FBQTtBQUVyQyxPQUFPLE1BQU0sRUFBRSxFQUFFLEdBQUcsRUFBRSxNQUFNLG1CQUFtQixDQUFBO0FBRS9DLE9BQU8sRUFBRSxLQUFLLEVBQUUsTUFBTSxVQUFVLENBQUE7QUFDaEMsT0FBTyxFQUFFLGNBQWMsRUFBRSxNQUFNLFNBQVMsQ0FBQTtBQUl4QyxjQUFjLFNBQVMsQ0FBQTtBQUV2QixNQUFNLENBQUMsTUFBTSxRQUFRLEdBQW1CLENBQUMsRUFVeEMsRUFBRSxFQUFFO1FBVm9DLEVBQ3ZDLHFCQUFxQixHQUFHLElBQUksRUFDNUIsc0JBQXNCLEdBQUcsSUFBSSxFQUM3Qix5QkFBeUIsR0FBRyxJQUFJLEVBQ2hDLFFBQVEsR0FBRyxLQUFLLEVBQ2hCLGNBQWMsR0FBRyxLQUFLLEVBQ3RCLGFBQWEsR0FBRyxLQUFLLEVBQ3JCLElBQUksR0FBRyxRQUFRLEVBQ2YsS0FBSyxPQUVOLEVBREksS0FBSyxjQVQrQixnSkFVeEMsQ0FEUztJQUVSLE1BQU0sRUFBRSxDQUFDLEVBQUUsR0FBRyxjQUFjLEVBQUUsQ0FBQTtJQUU5QixPQUFPLENBQ0wsS0FBQyxXQUFXO0lBQ1YsMENBQTBDOztRQUExQywwQ0FBMEM7UUFDMUMsU0FBUyxFQUFFLFFBQVEsRUFDbkIsZUFBZSxFQUFFLGNBQWMsRUFDL0IsS0FBSyxFQUFFLElBQUksRUFDWCxhQUFhLEVBQUUsYUFBYTtRQUM1QiwyREFBMkQ7UUFDM0QsVUFBVSxFQUFFLEtBQUssRUFDakIsWUFBWSxFQUFFLENBQUMsT0FBTyxFQUFFLEtBQUssRUFBRSxFQUFFLENBQUMsQ0FBQyxLQUFLLEdBQUcsQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUMsVUFBVSxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsRUFDckUscUJBQXFCLEVBQUUscUJBQXFCLEVBQzVDLHNCQUFzQixFQUFFLHNCQUFzQixFQUM5Qyx5QkFBeUIsRUFBRSx5QkFBeUIsRUFDcEQsTUFBTSxFQUFFO1lBQ04sU0FBUyxFQUFFLEtBQUssYUFBTCxLQUFLLGNBQUwsS0FBSyxHQUFJLEtBQUMsS0FBSyxDQUFDLEtBQUssSUFBQyxXQUFXLEVBQUUsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxXQUFJO1NBQzVELElBQ0csS0FBSyxVQUNULENBQ0gsQ0FBQTtBQUNILENBQUMsQ0FBQTtBQUVELE1BQU0sQ0FBQyxNQUFNLEtBQUssR0FBRyxRQUVFLENBQUE7QUFFdkIsTUFBTSxXQUFXLEdBQUcsTUFBTSxDQUFDLFNBQVMsQ0FBQyxDQVFuQzs7Ozs7Ozs7Z0JBUWMsS0FBSyxDQUFDLEVBQUUsQ0FBQyxDQUFDLEtBQUssQ0FBQyxLQUFLLEtBQUssT0FBTyxDQUFDLENBQUMsQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDLE1BQU0sQ0FBQztpQkFDbkQsS0FBSyxDQUFDLEVBQUUsQ0FBQyxDQUFDLEtBQUssQ0FBQyxLQUFLLEtBQUssT0FBTyxDQUFDLENBQUMsQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDLFFBQVEsQ0FBQzs7Ozs7O2lCQU14RCxLQUFLLENBQUMsRUFBRSxDQUFDLENBQUMsS0FBSyxDQUFDLEtBQUssS0FBSyxPQUFPLENBQUMsQ0FBQyxDQUFDLFVBQVUsQ0FBQyxDQUFDLENBQUMsV0FBVyxDQUFDO21CQUMzRCxLQUFLLENBQUMsRUFBRSxDQUFDLENBQUMsS0FBSyxDQUFDLEtBQUssS0FBSyxPQUFPLENBQUMsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDOzs7O1VBSTdELEtBQUssQ0FBQyxFQUFFLENBQUMsQ0FBQyxLQUFLLENBQUMsYUFBYSxDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLE9BQU8sQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLFNBQVMsQ0FBQzs7Ozs7Ozs7Ozs7OztVQWFuRSxLQUFLLENBQUMsRUFBRSxDQUFDLENBQUMsS0FBSyxDQUFDLGFBQWEsQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDLEtBQUssQ0FBQyxPQUFPLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxTQUFTLENBQUM7Ozs7Ozs7OztvQkFTekQsS0FBSyxDQUFDLEVBQUUsQ0FDcEIsS0FBSyxDQUFDLHNCQUFzQixDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLEtBQUssQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLGFBQWE7Ozs7O29CQUt2RCxDQUFDLENBQUMsRUFBRSxDQUNoQixDQUFDLENBQUMseUJBQXlCLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsYUFBYTs7Ozs7Ozs7Ozs7TUFXaEUsS0FBSyxDQUFDLEVBQUUsQ0FDUixLQUFLLENBQUMscUJBQXFCO0lBQzNCLEdBQUcsQ0FBQTs7OzBCQUdpQixLQUFLLENBQUMsS0FBSyxDQUFDLFVBQVUsQ0FBQyxFQUFFOzs7MEJBR3pCLEtBQUssQ0FBQyxzQkFBc0I7UUFDeEMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLEVBQUU7UUFDdEIsQ0FBQyxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsVUFBVSxDQUFDLEVBQUU7OztPQUdsQzs7TUFFRCxLQUFLLENBQUMsRUFBRSxDQUNSLEtBQUssQ0FBQyxTQUFTO0lBQ2YsR0FBRyxDQUFBOzs7O3lCQUlnQixLQUFLLENBQUMsZUFBZTtRQUNwQyxDQUFDLENBQUMsQ0FBQztRQUNILENBQUMsQ0FBQyxLQUFLLENBQUMsS0FBSyxLQUFLLE9BQU87WUFDekIsQ0FBQyxDQUFDLEtBQUs7WUFDUCxDQUFDLENBQUMsS0FBSzs7Ozs7T0FLVjs7TUFFRCxLQUFLLENBQUMsRUFBRSxDQUNSLEtBQUssQ0FBQyxhQUFhO0lBQ25CLEdBQUcsQ0FBQTs7O29DQUcyQixLQUFLLENBQUMsS0FBSyxDQUFDLE9BQU8sQ0FBQyxFQUFFOztPQUVuRDs7UUFFQyxLQUFLLENBQUMsRUFBRSxDQUNWLEtBQUssQ0FBQyxTQUFTO0lBQ2YsR0FBRyxDQUFBOzs7OztPQUtGOztDQUVOLENBQUEifQ==